module.exports = __webpack_public_path__ + "img/zfa.89fc553b.png";